// extracted by mini-css-extract-plugin
export default {"item":"Item_item","notOwn":"Item_notOwn","nationWrapper":"Item_nationWrapper","nationIcon":"Item_nationIcon"};